import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <g clipPath="url(#enrichedIcon-DailyLogsInverted_svg__a)">
      <path
        fill="#D8FFFF"
        d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
      />
      <path
        stroke="#00D8D8"
        strokeMiterlimit={10}
        strokeWidth={2}
        d="M97.533 79.571a5 5 0 1 0 0-10 5 5 0 0 0 0 10Z"
      />
      <path
        fill="#0597A3"
        d="M95.033 44.969a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
      />
      <path
        fill="#00D8D8"
        d="M16.415 53.793a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7"
      />
      <path
        stroke="#00D8D8"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={3}
        d="m20.667 90.503-9.994 9.994M20.667 100.497l-9.994-9.994M107.533 24.316V38.45M114.6 31.384h-14.134"
      />
      <path
        fill="#00D8D8"
        d="M83.387 24.148H37.835a4.59 4.59 0 0 0-4.591 4.59v56.09a4.59 4.59 0 0 0 4.59 4.591h45.553a4.59 4.59 0 0 0 4.59-4.59v-56.09a4.59 4.59 0 0 0-4.59-4.591"
      />
      <path
        fill="#0597A3"
        d="M27.814 33.651h5.43v6.688h-5.43a3.345 3.345 0 0 1 0-6.688M27.814 46.844h5.43v6.688h-5.43a3.345 3.345 0 0 1 0-6.688M27.814 60.035h5.43v6.688h-5.43a3.345 3.345 0 0 1 0-6.688M27.814 73.227h5.43v6.688h-5.43a3.345 3.345 0 0 1 0-6.688M77.183 48.954l-5.019-2.565a1.66 1.66 0 0 0-1.51 0l-5.019 2.564a1.66 1.66 0 0 1-2.415-1.478V24.147h16.378v23.329a1.66 1.66 0 0 1-2.415 1.477"
      />
    </g>
    <defs>
      <clipPath id="enrichedIcon-DailyLogsInverted_svg__a">
        <path fill="#fff" d="M0 0h116v116H0z" />
      </clipPath>
    </defs>
  </svg>
);
const SvgEnrichedIconDailyLogsInverted = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconDailyLogsInverted);
export default Memo;
